import * as _d3oe from "@bfx/d3";
import { BfxOrderEntryStrategyLayoutPlugin } from "./strategy-layout/BfxOrderEntryStrategyLayoutPlugin";

// Refactor
export const d3oe = (function () {
  _d3oe.layout.entryStrategy = function (pricingService, actionsService) {
    return new BfxOrderEntryStrategyLayoutPlugin(pricingService, actionsService);
  };

  return _d3oe;
})();
